(() => {
 'use strict';
 let busy = false;
 const root = window.Shopify?.routes?.root || '/';
 const sliders = () => Array.from(document.querySelectorAll('[data-cart-offers]'));
 let feedback = '';
 const allocations = item => item.line_level_discount_allocations || [];
 const titleOf = discount => discount.discount_application?.title || '';
 function state(cart, slider) {
  const ownTitle = slider.dataset.discountTitle;
  let total = 0, gift = false, claimed = false;
  cart.items.forEach(item => {
   const props = item.properties || {};
   let excluded = props._vm_cart_offer === 'true' || !!props._vm_campaign || !!props._vm_gift;
   if (props._vm_cart_offer === 'true' && !props._vm_campaign && !props._vm_gift) claimed = true;
   allocations(item).forEach(discount => {
    const title = titleOf(discount);
    if (title === slider.dataset.giftTitle) gift = true;
    if (title !== ownTitle) excluded = true;
    else if (Number(discount.amount) > 0) { excluded = true; claimed = true; }
   });
   if (!excluded) total += Number(item.original_line_price) || 0;
  });
  return { total, gift, claimed };
 }
 function updateState(slider, cart) {
  const current = state(cart, slider);
  slider.dataset.total = current.total;
  slider.dataset.giftActive = String(current.gift);
  slider.dataset.offerClaimed = String(current.claimed);
  slider.querySelectorAll('[data-offer-product]').forEach(card => {
   card.hidden = cart.items.some(item => String(item.product_id) === card.dataset.offerProduct) ||
    (current.gift && card.dataset.giftConflict === 'true');
  });
 }
 function eligible(slider, cart) {
  const current = cart ? state(cart, slider) : { total: Number(slider.dataset.total), claimed: slider.dataset.offerClaimed === 'true' };
  const currency = cart?.currency || slider.dataset.currency;
  const rate = currency === slider.dataset.shopCurrency ? 1 : Number(window.Shopify?.currency?.rate);
  return !current.claimed && Number.isFinite(rate) && rate > 0 && current.total >= Math.round(Number(slider.dataset.minimum) * rate);
 }
 function publish(cart) {
  sliders().forEach(area => updateState(area, cart));
  const core = window.themeCore;
  if (core?.EventBus) {
   core.cartObject = cart;
   core.EventBus.emit('cart:updated', { ...cart, action: 'update', params: [{ noOpen: true }] });
   core.EventBus.emit('header:update-item-count', { item_count: cart.item_count });
  } else location.reload();
 }
 function verified(item, slider) {
  if (!item) return false;
  const actual = allocations(item).filter(d => titleOf(d) === slider.dataset.discountTitle).reduce((n,d) => n + Number(d.amount || 0), 0);
  const expected = Math.floor(Number(item.original_line_price) * Number(slider.dataset.discount) / 100);
  return expected > 0 && actual >= expected && Number(item.final_line_price) <= Number(item.original_line_price) - expected;
 }
 function arrows(slider) {
  const track = slider.querySelector('.vm-offers__track');
  slider.querySelector('[data-offer-prev]').disabled = track.scrollLeft <= 2;
  slider.querySelector('[data-offer-next]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
 }
 function sync() {
  document.querySelectorAll('[data-cart-offer-feedback]').forEach(node => { node.textContent = feedback; node.hidden = !feedback; });
  sliders().forEach(slider => {
   slider.hidden = !eligible(slider) || !slider.querySelector('[data-offer-product]:not([hidden])');
   slider.querySelectorAll('[data-offer-add], select').forEach(control => { control.disabled = busy; });
   if (!slider.dataset.ready) {
    slider.dataset.ready = 'true';
    slider.querySelector('.vm-offers__track').addEventListener('scroll', () => arrows(slider), { passive: true });
   }
   arrows(slider);
  });
 }
 async function request(path, options) {
  const response = await fetch(root + path, { cache: 'no-store', ...options });
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || 'Ürün eklenemedi. Lütfen tekrar deneyin.');
  return data;
 }
 document.addEventListener('change', event => {
  if (!event.target.matches('select[data-offer-variant]')) return;
  const card = event.target.closest('[data-offer-product]'), option = event.target.selectedOptions[0];
  card.querySelector('[data-offer-old]').textContent = option.dataset.old;
  card.querySelector('[data-offer-new]').textContent = option.dataset.new;
 });
 document.addEventListener('click', async event => {
  const slider = event.target.closest('[data-cart-offers]');
  if (!slider) return;
  const direction = event.target.closest('[data-offer-prev], [data-offer-next]');
  if (direction) {
   const track = slider.querySelector('.vm-offers__track');
   track.scrollBy({ left: (direction.hasAttribute('data-offer-next') ? 1 : -1) * (track.querySelector('.vm-offers__card')?.offsetWidth + 10 || 235), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
   return;
  }
  const button = event.target.closest('[data-offer-add]');
  if (!button || busy) return;
  busy = true; sync();
  const card = button.closest('[data-offer-product]');
  const selector = card.querySelector('[data-offer-variant]');
  const variant = selector.selectedOptions ? selector.selectedOptions[0] : selector;
  const status = slider.querySelector('[data-offer-status]');
  status.textContent = 'Ekleniyor…';
  let attempted = false, confirmed = false;
  const token = 'offer-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  async function rollback() {
   const current = await request('cart.js');
   const lines = current.items.filter(item => item.properties?._vm_offer_token === token);
   for (const line of lines) await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
   const restored = await request('cart.js');
   if (restored.items.some(item => item.properties?._vm_offer_token === token)) throw new Error('rollback');
   return restored;
  }
  feedback = '';
  try {
   const before = await request('cart.js');
   sliders().forEach(area => updateState(area, before));
   if (!eligible(slider, before) || (state(before, slider).gift && card.dataset.giftConflict === 'true')) {
    feedback = 'Sepetiniz değişti. Bu teklif şu anda kullanılamıyor.'; publish(before); return;
   }
   if (before.items.some(item => String(item.product_id) === card.dataset.offerProduct)) {
    feedback = 'Bu ürün zaten sepetinizde.'; return;
   }
   if ((Number(variant.dataset.quantity) || 1) > 1) {
    feedback = 'Bu ürün tek adet teklifine uygun değil.'; return;
   }
   attempted = true;
   await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: 1, properties: { _vm_cart_offer: 'true', _vm_offer_token: token } }] }) });
   const cart = await request('cart.js');
   const line = cart.items.find(item => item.properties?._vm_offer_token === token);
   // Also reject a new offer if adding it revoked an existing product discount.
   const previousSavings = before.items.reduce((sum,item) => sum + allocations(item).reduce((n,d) => n + Number(d.amount || 0), 0), 0);
   const remainingSavings = cart.items.filter(item => item.properties?._vm_offer_token !== token).reduce((sum,item) => sum + allocations(item).reduce((n,d) => n + Number(d.amount || 0), 0), 0);
   if (!verified(line, slider) || remainingSavings < previousSavings) {
    const restored = await rollback();
    attempted = false;
    feedback = 'Bu teklif mevcut kampanyanızla uygulanamadı. Eklenen teklif ürünü geri çıkarıldı.';
    publish(restored); return;
   }
   confirmed = true;
   feedback = 'Ürün indirimli olarak sepetinize eklendi.';
   publish(cart);
  } catch (error) {
   if (attempted && !confirmed) {
    try {
     const restored = await rollback();
     feedback = 'İndirim doğrulanamadı. Test edilen teklif ürünü sepetten çıkarıldı.';
     publish(restored);
    } catch (_) {
     feedback = 'İndirim ve geri alma işlemi doğrulanamadı. Ödemeye geçmeden önce sepetinizdeki teklif ürününü ve fiyatını kontrol edin.';
    }
   } else feedback = confirmed ? 'Ürün indirimli eklendi. Güncel sepeti görmek için sayfayı yenileyin.' : error.message;
  } finally { busy = false; sync(); }
 });
 let queued = false;
 new MutationObserver(records => {
  if (queued || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('[data-cart-offers]') || node.querySelector?.('[data-cart-offers]') || node.matches?.('[data-cart-offer-feedback]'))))) return;
  queued = true; requestAnimationFrame(() => { queued = false; sync(); });
 }).observe(document.body, { childList: true, subtree: true });
 window.addEventListener('resize', sync);
 // Drawer animation changes width without a window resize.
 document.addEventListener('transitionend', () => sliders().forEach(arrows));
 sync();
})();
